module.exports = __webpack_public_path__ + "img/img_swim_app1_en.71fcce4a.png";